import clsx from "clsx";
import Cookies from "js-cookie";
import React, { useEffect, useState, useRef } from "react";
import { blob } from "stream/consumers";
import {
  MetaDataList,
  MetaDataDetails,
  MetaDataDetailsExecute,
  MetaDataDetailsDownload,
  GetApiData,
  GetDyanmicFormApiData,
} from "../../api/api";
import { Button } from "../../components/Button/Button";
import { TableData } from "./tabledata";
import Switch from "react-switch";
import _ from "lodash";
import { MultiSelect } from "react-multi-select-component";

const TaskList = () => {
  const [metaDataList, setMetaDataList] = useState<any>();
  const [selectedId, setSelectedId] = useState<any>(null);
  const [getMetaValue, setGetMetaValue] = useState<any>(null);
  const [selectedName, setSelectedName] = useState<any>(null);
  const [getExecuteValue, setGetExecuteValue] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [getTaskDownload, setGetTaskDownload] = useState("");
  const [isDownload, setIsDownload] = useState(false);
  const [filterFundId, setFilterFundId] = useState<any>(null);
  const [getFundList, setGetFundList] = useState<any>(null);
  const [showControls, setShowControls] = useState<any>(null);
  const [ToggleButton, setToggleButton] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const [data, setData] = useState<any>('');
  // useEffect(() => {
  //   if (selectedDate === "") {
  //     setGetExecuteValue(null);
  //   }
  // }, [selectedDate]);
console.log(selectedName)
  function handleChange(e: any) {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    setSelectedName(e.target.value);
    if (e.target.value === null) {
      setSelectedDate("");
    }

    return setSelectedId(el.getAttribute("id"));
  }

  function handleDateChange(e: any) {
    console.log(e.target.value)
    const dateObj = new Date(e.target.value);
const year = dateObj.getFullYear();
const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
const day = ('0' + dateObj.getDate()).slice(-2);
const hours = ('0' + dateObj.getHours()).slice(-2);
const minutes = ('0' + dateObj.getMinutes()).slice(-2);
const seconds = ('0' + dateObj.getSeconds()).slice(-2);

const formattedDate = `${year}-${month}-${day}`;
console.log(formattedDate);
    return setData({
      ...data,
      [e.target.name]: formattedDate,
    });
    ;
  }

  function handleProcessSecurity() {
    console.log(selectedName, data)
    if (
      selectedId !== null &&
      selectedDate !== null &&
      selectedName !== "ExportSecurityPositionsData"
    ) {
      MetaDataDetailsExecute(selectedName, selectedDate, Cookies.get("newJwt"))
        .then((response) => response.json())
        
        .then((response) => {
          console.log(response)
          setGetExecuteValue(response);
          setSectorCount(response);
        });
    }
  }

  function handleDownload(e: any) {
    return setGetTaskDownload(e.target.value);
  }

  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setGetExecuteValue(
      sectorCount.slice(pageNumbers * 15 - 15, pageNumbers * 15)
    );
    setSectorCurrentPage(pageNumbers);
  };

  //react arrow function ?
  // function handleDownloadFile() {
  //   var token = Cookies.get("newJwt");
  //   setIsDownload(true);
  //   let extension = "";
  //   if (`${getTaskDownload}` === "PDF") {
  //     extension = "pdf";
  //   }
  //   if (`${getTaskDownload}` === "CSV") {
  //     extension = "csv";
  //   }
  //   if (`${getTaskDownload}` === "Excel") {
  //     extension = ".xlsx";
  //   }

  //   var raw = JSON.stringify({
  //     Type: `${getTaskDownload.toLocaleLowerCase()}`,
  //     data: {
  //       EndDate: `${selectedDate}`,
  //     },
  //   });

  //   var requestOptions = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${token}`,
  //     },
  //     body: raw,
  //   };
  //   fetch(
  //     `https://ims.akrais.com:8444/PMSWEBAPI/api/metadata/ExportSecurityPositionsData/download`,
  //     requestOptions
  //   ).then((response) => {
  //     response.blob().then((blob) => {
  //       const fileURL = window.URL.createObjectURL(blob);
  //       let alink = document.createElement("a");
  //       alink.href = fileURL;
  //       alink.download = `sample.${extension}`;
  //       alink.click();
  //       setIsDownload(false);
  //     });
  //   });
  // }

  useEffect(() => {
    if (
      filterFundId !== null &&
      selectedId === "6982dd6e-a482-4fb5-b103-2028e454a6d8"
    ) {
      const FundId = filterFundId?.id;
      GetApiData(FundId, "Fund", Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          setGetFundList(response);
        });
    }
  }, [filterFundId]);

  const handleSelectChange = (e: any) => {};
  const handleSelectFundChange = (e: any) => {
    return console.log(e);
  };
  console.log(getFundList);
  

  const [selected, setSelected] = useState<any>([]);

  const taskOptions: any = metaDataList?.map((e: any) => {
    return { label: e.name, value: e.id };
  });
  useEffect(() => {
    if (selected.length > 1) {
      setSelected([selected[selected.length - 1]]);
    }
  }, [selected]);

  useEffect(() => {
    let selectedResult = selected.map((value: any) => value);
    var taskItem = selectedResult.find((e: any) => e.value);
    setSelectedId(taskItem?.value);
    setSelectedName(taskItem?.label);
  }, [selected]);

  useEffect(() => {
    if (selectedId !== null) {
      MetaDataDetails(selectedId, Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          setGetMetaValue(response);
          setFilterFundId(_.find(response, ["name", "FundID"]));
        });
    }
  }, [selectedId]);

  useEffect(() => {
    const a = _.find(metaDataList, ["name", selectedName]);
    setShowControls(a);
    console.log(a);
  }, [selectedName]);

  useEffect(() => {
    MetaDataList(Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setMetaDataList(response);
      });
  }, []);
  

  const updateData = (e: any) => {
    setData({
      ...data,
      [e.target.name]: e.target.type === "number" ? parseInt(e.target.value) : e.target.value,
    });
  };
  const handleChangeSwitch = (e: any) => {
    setToggleButton({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  console.log(data);
  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    
    var token = Cookies.get("newJwt");
    setIsDownload(true);
    let extension = "";
    if (`${getTaskDownload}` === "PDF") {
      extension = "pdf";
    }
    if (`${getTaskDownload}` === "CSV") {
      extension = "csv";
    }
    if (`${getTaskDownload}` === "Excel") {
      extension = ".xlsx";
    }

    var raw = JSON.stringify({
      Type: `${getTaskDownload.toLocaleLowerCase()}`,
      
        data,
        //EndDate: `${selectedDate}`,
      
    });

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: raw,
    };
    fetch(
      `https://ims.akrais.com:8444/PMSWEBAPI/api/metadata/${selectedName}/download`,
      requestOptions
    )
    .then((response) => {
      
        response.blob().then((blob) => {
          const fileURL = window.URL.createObjectURL(blob);
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = `sample.${extension}`;
          alink.click();
          setIsDownload(false);
        });
      
    })
    .catch((error) => {
      console.error("An error occurred while downloading the file", error.message);

    });



  };

  console.log(getMetaValue)
  console.log(metaDataList)
  console.log(showControls)
  return (
    <div>
      <div className="header">
        <h1 className="header-title">Task</h1>
      </div>
      <div className="row w-100 card p-4">
        <div className="w-100 tradeForm position-relative">
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Task:</label>
            <div className="col-sm-10">
              {taskOptions ? (
                <MultiSelect
                  options={taskOptions}
                  value={selected}
                  hasSelectAll={false}
                  onChange={setSelected}
                  labelledBy="Select Benchmark"
                  className="multiSelect w-25 taskSelection"
                  closeOnChangedValue={true}
                />
              ) : null}

              {/* <select className="form-control w-25" onChange={handleChange}>
                <option>Select</option>
                {metaDataList ? (
                  metaDataList &&
                  metaDataList.map((e: any) => {
                    return (
                      <option key={e.id} id={e.id}>
                        {e.name}
                      </option>
                    );
                  })
                ) : (
                  <option value="">Loading...</option>
                )}
              </select> */}
            </div>
          </div>

          <form onSubmit={handleFormSubmit}>
            {/* {selectedId &&
            selectedId !== null &&
            selectedName !== "GetUserList" &&
            selectedId !== "295a0a04-3363-4b43-9cb4-4f34d59c6ba9" &&
            selectedId !== "6982dd6e-a482-4fb5-b103-2028e454a6d8" &&
            selectedId !== "295a0a04-3363-4b43-9cb4-4f34d59c6ba9" ? (
              <>
                <div className="form-group row my-4">
                  <div className="d-flex py-2">
                    <label className="col-sm-2 col-form-label">
                      {getMetaValue?.map((e: any) => {
                        return e.label;
                      })}{" "}
                    </label>
                    {getMetaValue?.map((e: any) => {
                      return e.type === "date" ? (
                        <>
                          <div className="col-sm-10">
                            <input
                              type={e.type}
                              placeholder="mm-dd-yyyy"
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            />
                          </div>
                        </>
                      ) : null;
                    })}{" "}
                  </div>
                </div>
              </>
            ) : null} */}
            {/* {selectedName &&
            selectedName === "ExportSecurityPositionsData" &&
            selectedDate !== "" ? (
              <>
                <div className="form-group row my-4">
                  <label className="col-sm-2 col-form-label">Download</label>
                  <div className="col-sm-10">
                    <select
                      className="form-control w-25"
                      onChange={handleDownload}
                    >
                      <option>Excel</option>
                      <option>CSV</option>
                      <option>PDF</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Button
                    children="Download"
                    type="button"
                    className="btn btn-primary float-end"
                    size="btn-xs"
                    onClick={handleDownloadFile}
                    showLoading={isDownload}
                  />
                </div>
              </>
            ) : null} */}
            {selectedId && selectedId !== null ? (
              <>
                <div className="form-group row my-4">
                  {getMetaValue?.map((e: any) => {
                    return e.parameterType === "IN" ? (
                      <div className="d-flex py-2">
                        <label className="col-form-label col-sm-2">
                          {e.name}
                        </label>

                        <div className="col-sm-10">
                          {/* {e.name === "FundID" ? (
                            <select
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            >
                              
                              {getFundList?.map((item: any) => {
                                return (
                                  <option
                                    defaultValue="select"
                                    value={item.fundID}
                                  >
                                    {item.fundName}
                                  </option>
                                );
                              })}
                            </select>
                          ) : null} */}
                          {e.inputType === "select" ? (
                            <>
                              {e.options.length > 0 ? (
                                <select
                                  className="form-control w-25"
                                  name={e.label}
                                  onChange={updateData}
                                >
                                  <option value="">Select</option>

                                  {e.options.map((item: any) => {
                                    return (
                                      <option value={item.value}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                              ) : (
                                <select
                                  className="form-control w-25"
                                  name={e.label}
                                  onChange={updateData}
                                >
                                  <option value="">Select</option>

                                  {e.inputDataSource.map((item: any) => {
                                    return (
                                      <option
                                        value={item?.parameterData?.[0].key}
                                      >
                                        {item?.parameterData?.[0].val}
                                      </option>
                                    );
                                  })}
                                </select>
                              )}
                            </>
                          ) : null}
                          {e.inputType === "SelectList" ? (
                            <select
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            >
                              <option value="">Select</option>
                              <option value="">
                                {e.inputDataSource.map((item: any) => {
                                  return item.value;
                                })}
                              </option>
                            </select>
                          ) : null}
                          {e.inputType === "text" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              name={e.label}
                              className="form-control w-25"
                              onChange={updateData}
                            />
                          ) : null}
                          {e.inputType === "file" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            />
                          ) : null}
                          {e.inputType === "number" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            />
                          ) : null}
                          {e.inputType === "maskedtext" ? (
                            <input
                              type="text"
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.name}
                              onChange={updateData}
                            />
                          ) : null}
                          {e.inputType === "date" ? (
                            <input
                              type="date"
                              placeholder="mm-dd-yyyy"
                              className="form-control w-25"
                              name={e.label}
                              onChange={handleDateChange}
                            />
                          ) : null}
                          {e.inputType === "textarea" ? (
                            <textarea
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              //rows="3"
                              name={e.label}
                              onChange={updateData}
                            />
                          ) : null}
                          {e.inputType === "radio" ? (
                            <>
                              <form name={e.name} onChange={updateData}>
                                {e.options.map((item: any) => {
                                  return (
                                    <div className="form-check form-check-inline py-1">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        id="inlineRadio1"
                                        value={item.value}
                                        name={e.name}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio1"
                                      >
                                        {item.label}
                                      </label>
                                    </div>
                                  );
                                })}
                              </form>
                            </>
                          ) : null}

                          {e.inputType === "checkboxgroup" ? (
                            <form name={e.name} onChange={updateData}>
                              {e.options.map((item: any) => {
                                return (
                                  <div className="form-check form-check-inline py-1">
                                    <input
                                      type="checkbox"
                                      placeholder={e.placeHolder}
                                      className="form-check-input my-2"
                                      name={e.label}
                                      onChange={updateData}
                                    />
                                    <label
                                      className="form-check-label py-1"
                                      htmlFor="inlineCheckBOx1"
                                    >
                                      {item.label}
                                    </label>
                                  </div>
                                );
                              })}
                            </form>
                          ) : null}

                          {e.inputType === "switch" ? (
                            <Switch
                              checked={ToggleButton}
                              onChange={handleChangeSwitch}
                              onColor="#33B271"
                              onHandleColor="#fff"
                              handleDiameter={30}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={48}
                              className="react-switch my-2"
                              name={e.label}
                              //onChange={() => updateData((current:any) => !current)}
                            />
                          ) : null}
                          {e.inputType === "button" ? (
                            <button className="btn btn-primary">
                              {e?.label}
                            </button>
                          ) : null}
                        </div>
                      </div>
                    ) : null;
                  })}{" "}
                  {showControls?.allowExecute === true ? (
                    <div className="form-group row my-4">
                      <label className="col-sm-2 col-form-label">
                        Download
                      </label>
                      <div className="col-sm-10">
                        <select
                          className="form-control w-25"
                          onChange={handleDownload}
                        >
                          <option value="">Select</option>

                          {showControls?.allowPdfExport === true && (
                            <option value="pdf">PDF</option>
                          )}
                          {showControls?.allowCsvExport === true && (
                            <option value="csv">CSV</option>
                          )}
                          {showControls?.allowExcelExport === true && (
                            <option value="excel">Excel</option>
                          )}
                        </select>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-sm-12 mb-4">
                    <button
                      type="submit"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end "
                    >
                      {showControls?.submitButtonText !== null
                        ? showControls?.submitButtonText
                        : "Submit"}
                    </button>
                    <button
                      type="button"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-link float-end"
                    >
                      {showControls?.cancelButtonText !== null
                        ? showControls?.cancelButtonText
                        : "Cancel"}
                    </button>
                  </div>
                </div>
              </>
            ) : null}
          </form>
          {selectedName && selectedName === "ProcessSecurityPositionsData" ? (
            <div className="col-sm-12 mb-4">
              <Button
                children="Submit"
                type="button"
                className="btn btn-primary float-end"
                size="btn-xs"
                onClick={handleProcessSecurity}
                showLoading={isDownload}
              />
            </div>
          ) : null}
          {selectedName &&
          selectedName === "GetSecurityPositionsData" &&
          selectedDate !== "" ? (
            <TableData
              selectedId={selectedId}
              selectedDate={selectedDate}
              getExecuteValue={getExecuteValue}
              sectorCount={sectorCount}
              SectorpageHandler={SectorpageHandler}
              SectorCurrentPage={SectorCurrentPage}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export { TaskList };
